interface DeleteConfirmModalProps {
  title: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteConfirmModal = ({ title, onConfirm, onCancel }: DeleteConfirmModalProps) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onCancel} />
    <div className="relative bg-white rounded-2xl w-full max-w-sm p-6 z-10">
      <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-red-50 mx-auto mb-4">
        <i className="ri-delete-bin-6-line text-red-500 text-2xl" />
      </div>
      <h3 className="text-lg font-bold text-gray-900 text-center mb-2">Delete Product?</h3>
      <p className="text-sm text-gray-500 text-center mb-6">
        Are you sure you want to delete <span className="font-semibold text-gray-700">&quot;{title}&quot;</span>? This action cannot be undone.
      </p>
      <div className="flex gap-3">
        <button
          onClick={onCancel}
          className="flex-1 py-3 rounded-xl border-2 border-gray-200 text-sm font-semibold text-gray-600 hover:bg-gray-50 cursor-pointer whitespace-nowrap transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={onConfirm}
          className="flex-1 py-3 rounded-xl bg-red-500 text-white text-sm font-semibold hover:bg-red-600 cursor-pointer whitespace-nowrap transition-colors"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
);

export default DeleteConfirmModal;